var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ConsultBanner'),_c('ConsultTitle1'),_c('ConsultCards'),_c('ConsultIntroduction'),_c('ConsultGuide'),_c('ConsultBanner3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }